import { useSearchParams } from 'next/navigation';
import { Key, useCallback } from 'react';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { LocationData } from '@provider-directory/types/locations.contracts';
import { getCompleteSearchParams } from '@provider-directory/types/search.model';

type FilterValue = Set<Key> | Key | LocationData | null;

interface UseSearchAnalyticsReturn {
  sendFilterUpdateAnalytics: (key: string, option: FilterValue) => void;
}

export const useSearchAnalytics = (): UseSearchAnalyticsReturn => {
  const analytics = useAnalytics();
  const searchParams = useSearchParams();

  const sendFilterUpdateAnalytics = useCallback(
    (key: string, option: FilterValue) => {
      if (!analytics) return;
      const searchParamsForAnalytics = Object.entries(
        getCompleteSearchParams(searchParams),
      ).reduce(
        (acc, [p, value]) => ({
          ...acc,
          [`search.${p}`]: value,
        }),
        {},
      );
      const valueForAnalytics =
        option instanceof Set ? Array.from(option) : option;
      analytics.updatedSearchFilterEvent({
        filter: key,
        value: valueForAnalytics,
        searchParams: searchParamsForAnalytics,
        linkContextPage: 'SearchResults',
        linkContextComponent: 'SearchFilters',
      });
    },
    [analytics, searchParams],
  );

  return { sendFilterUpdateAnalytics };
};
